import React from "react";
// import bgImg from '../../assets/Rectangle04.png';
import COLORS from '../constants/colors';

const eligibilityCards = [
  {
    number: "01",
    text: (
      <>
        Educate accident victims about their legal rights and options
      </>
    ),
    bg: "bg-[#FDF9ED]",
  },
  {
    number: "02",
    text: (
      <>
        Provide free,<br />
        no-obligation<br />
        case<br />
        evaluations
      </>
    ),
    bg: "bg-[#F3F4F9]",
  },
  {
    number: "03",
    text: (
      <>
        Connect qualified individuals with top accident attorneys across the U.S.
      </>
    ),
    bg: "bg-[#FDF9ED]",
  },
  {
    number: "04",
    text: (
      <>
        Offer a safe,<br />
        private process<br />
        to begin your<br />
        legal journey
      </>
    ),
    bg: "bg-[#F3F4F9]",
  },

];

const mobileEligibilityCards = eligibilityCards.map((card, index) => {
  // Alternate colors: odd indices get #FDF9ED, even indices get #F3F4F9
  // This creates: #FDF9ED, #F3F4F9, #FDF9ED, #F3F4F9, #FDF9ED
  if (index % 2 === 0) {
    return { ...card, bg: "!bg-[#FDF9ED]" };
  }
  return { ...card, bg: "!bg-[#F3F4F9]" };
});

export default function EligibilityCriteria() {
  return (
    <section
      className="w-full bg-white py-12 font-[Quicksand] bg-cover"
    // style={{ backgroundImage: `url(${bgImg})` }}
    >
      {/* Laptop & Large Screen Layout (≥1024px) - Horizontal Layout */}
      <div className="hidden lg:block max-w-[1440px] mx-auto 
  px-[57px] py-[43px]
  xl:px-[80px] xl:py-[60px]
  2xl:px-[96px] 2xl:py-[72px]">
        <div className="flex items-center gap-6 xl:gap-8 justify-evenly">



          {/* Text Block */}
          <div className="flex flex-col justify-center 
      w-[280px] h-[102px]
      xl:w-[394px] xl:h-[144px]
      2xl:w-[473px] 2xl:h-[173px]">
            <h2 className="font-[Quicksand] font-bold text-[28px] leading-[35px] max-w-[85vw] md:text-[32px] md:leading-[38px] md:max-w-[50vw] lg:text-[36px] lg:leading-[42px] lg:max-w-[45vw] xl:text-[48px] xl:leading-[56px] xl:max-w-[568px] 2xl:text-[56px] 2xl:leading-[64px] 2xl:max-w-[680px] min-[3840px]:text-[72px] min-[3840px]:leading-[80px] min-[3840px]:max-w-[1136px] capitalize leading-tight mb-2" style={{ color: COLORS.primaryBlue }}>
              Who We<span style={{ color: COLORS.buttonColor }}> Help</span>
            </h2>
            <p className="font-[Quicksand] text-[8px] leading-[8px] max-w-[318px] md:text-[10px] md:leading-[12px] md:max-w-[368px] lg:text-[12px] lg:leading-[14px] lg:max-w-[490px] xl:text-[16px] xl:leading-[22px] xl:max-w-[650px] 2xl:text-[20px] 2xl:leading-[25px] 2xl:max-w-[680px] min-[3840px]:text-[36px] min-[3840px]:leading-[40px] min-[3840px]:max-w-[1510px]" style={{ color: COLORS.gray }}>
              We assist individuals & families affected by:
            </p>
          </div>

          {/* Four Cards in Horizontal Line */}
          {eligibilityCards.slice(0, 4).map((card, index) => (
            <article
              key={card.number}
              className={`flex flex-col justify-center items-start gap-2 
          p-4 xl:p-6 2xl:p-7
          w-[137px] h-[102px]
          xl:w-[192px] xl:h-[144px]
          2xl:w-[230px] 2xl:h-[173px]
          rounded-[10px] ${card.bg} shadow-sm border border-white overflow-hidden`}
            >
              <span style={{ color: (index === 0 || index === 2) ? COLORS.yellow : COLORS.primaryBlue }} className="font-[Quicksand] font-bold leading-none 
          text-[25px] xl:text-[35px] 2xl:text-[42px]">
                {card.number}
              </span>
              <p className="font-[Quicksand] text-[2px] leading-[4px] max-w-[318px] md:text-[4px] md:leading-[6px] md:max-w-[368px] lg:text-[6px] lg:leading-[8px] lg:max-w-[490px] xl:text-[10px] xl:leading-[14px] xl:max-w-[650px] 2xl:text-[14px] 2xl:leading-[18px] 2xl:max-w-[680px] min-[3840px]:text-[24px] min-[3840px]:leading-[28px] min-[3840px]:max-w-[1510px] tracking-[-0.32px] capitalize text-left" style={{ color: COLORS.primaryBlue }}>
                {card.text}
              </p>
            </article>
          ))}
        </div>
      </div>

      {/*  Tablet Layout (md only) */}
      <div className="hidden md:flex lg:hidden max-w-[1200px] mx-auto flex-col items-center gap-6 px-4 py-2 md:gap-6 xl:gap-8">
        <div className="w-full text-center -mt-8">
          <h2 className="font-[Quicksand] font-bold text-[28px] leading-[35px] max-w-[85vw] md:text-[32px] md:leading-[38px] md:max-w-[50vw] lg:text-[36px] lg:leading-[42px] lg:max-w-[45vw] xl:text-[48px] xl:leading-[56px] xl:max-w-[568px] 2xl:text-[56px] 2xl:leading-[64px] 2xl:max-w-[680px] min-[3840px]:text-[72px] min-[3840px]:leading-[80px] min-[3840px]:max-w-[1136px] capitalize leading-normal" style={{ color: COLORS.primaryBlue }}>
            Who We<span style={{ color: COLORS.buttonColor }}> Help</span>
          </h2>

          <p className="font-[Quicksand] text-[8px] leading-[8px] max-w-[318px] md:text-[10px] md:leading-[12px] md:max-w-[368px] lg:text-[12px] lg:leading-[14px] lg:max-w-[490px] xl:text-[16px] xl:leading-[22px] xl:max-w-[650px] 2xl:text-[20px] 2xl:leading-[25px] 2xl:max-w-[680px] min-[3840px]:text-[36px] min-[3840px]:leading-[40px] min-[3840px]:max-w-[1510px] text-center mt-4" style={{ color: COLORS.gray }}>
            We assist individuals & families affected by:
          </p>
        </div>

        <div className="grid grid-cols-2 gap-8">
          {eligibilityCards.map((card, index) => {
            // Cards 1 and 4 get one color, cards 2 and 3 get another
            const cardBg = (index === 0 || index === 3) ? 'bg-[#FDF9ED]' : 'bg-[#F3F4F9]';
            const numberColor = (index === 0 || index === 3) ? COLORS.yellow : COLORS.primaryBlue;

            return (
              <article
                key={card.number}
                className={`flex flex-col justify-center items-start gap-3 p-6 h-[140px] rounded-[10px] ${cardBg} shadow-sm border border-white overflow-hidden`}
              >
                <span style={{ color: numberColor }} className="font-[Quicksand] font-bold leading-none text-[26px]">
                  {card.number}
                </span>
                <p className="font-[Quicksand] text-[2px] leading-[4px] max-w-[318px] md:text-[4px] md:leading-[6px] md:max-w-[368px] lg:text-[6px] lg:leading-[8px] lg:max-w-[490px] xl:text-[10px] xl:leading-[14px] xl:max-w-[650px] 2xl:text-[14px] 2xl:leading-[18px] 2xl:max-w-[680px] min-[3840px]:text-[24px] min-[3840px]:leading-[28px] min-[3840px]:max-w-[1510px] tracking-[-0.32px] capitalize text-left" style={{ color: COLORS.primaryBlue }}>
                  {card.text}
                </p>
              </article>
            );
          })}
        </div>
      </div>

      {/* Mobile Layout (below md) */}
      <div className="md:hidden flex flex-col items-center justify-center gap-6 px-4">
        <h2 className="font-[Quicksand] font-bold text-[24px] leading-normal capitalize text-left w-full" style={{ color: COLORS.primaryBlue }}>
          Who We<span style={{ color: COLORS.yellow }}> Help</span>
        </h2>
        <p className="font-[Quicksand] text-[15px] leading-normal text-left w-full" style={{ color: COLORS.gray }}>
          We assist individuals & families affected by:
        </p>

        <div className="flex flex-col gap-5 w-full max-w-[360px]">
          {mobileEligibilityCards.map((card, index) => {
            // Alternating number colors based on index
            const numberColor = index % 2 === 0 ? COLORS.yellow : COLORS.primaryBlue;

            return (
              <article
                key={card.number}
                className={`flex flex-col justify-center items-start text-left gap-3 p-5 h-[120px] rounded-[10px] ${card.bg} shadow-sm border border-white overflow-hidden`}
              >
                <span style={{ color: numberColor }} className="font-[Quicksand] font-bold leading-none text-[35px]">
                  {card.number}
                </span>
                <p className="font-[Quicksand] text-[9px] leading-normal tracking-[-0.32px] capitalize" style={{ color: COLORS.primaryBlue }}>
                  {card.text}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
